import React from "react";
import NotificationsContainer from "../../container/notifications";

const NotificationsScreen: React.FC<{}> = () => {
    return <NotificationsContainer/>;
}

export default NotificationsScreen;